import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../reducers/store";

const NotFound = () => {
    const auth = useSelector((state: RootState) => state.auth);
    let navigate = useNavigate();

    useEffect(() => {
        if (auth.token) {
            navigate("/");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth.token]);

    return <div>notFound</div>;
};

export default NotFound;
